import React from 'react'
import { useLanguage } from '../../contexts/LanguageContext'

const UnionOfTechnologyAndHealthcare = () => {
    const { t } = useLanguage();
  return (
    <div>
        <div id='website-responsive'>
            <div className='py-md-4 py-4' style={{ backgroundColor: '#FE9B1F' }}>
                <div className="mt-md-4 px-sm-4 px-md-0">
                    <center>
                        <h4 className="fs-ss-36 text-philos fw-600 text-ss-black" style={{ letterSpacing: '1px' }}>
                            {t('healthcare.unionOfTechnologyAndHealthcare.title')}
                        </h4>
                    </center>
                </div>

                <div className="left-padding10rem1 right-padding10rem1">
                    <div className='mb-4 mb-md-4 mt-md-4 mt-4'>
                        <center>
                            <p className='fs-ss-16 fw-500 text-mulish text-white' style={{ textAlign:''}}>
                            {t('healthcare.unionOfTechnologyAndHealthcare.content')}
                            </p>
                        </center>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default UnionOfTechnologyAndHealthcare